<template>
  <div>
    <div v-show="show" class="Preloader-styles-container"><div class="Spinner-styles-spinner-image"></div><span class="Preloader-styles-label"></span></div>
    <div class="placing" v-show="show === 5">
      <svg version="1.1" id="L2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
      <circle fill="none" stroke="#dc3545" stroke-width="6" stroke-miterlimit="15" cx="50" cy="50" r="45"></circle>
        <line fill="none" stroke-linecap="round" stroke="#dc3545" stroke-width="6" stroke-miterlimit="10" x1="50" y1="50" x2="85" y2="50.5">
        <animateTransform attributeName="transform" dur="2s" type="rotate" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform>
      </line>
        <line fill="none" stroke-linecap="round" stroke="#dc3545" stroke-width="6" stroke-miterlimit="10" x1="50" y1="50" x2="49.5" y2="74">
        <animateTransform attributeName="transform" dur="15s" type="rotate" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform>
      </line>
      </svg>
      <h3 v-show="status === 1">{{ t.bet_analyzing || '1/3 The bet(s) is analyzing...' }}</h3>
      <h3 v-show="status === 2">{{ t.bet_having_accepted || '2/3 The bet(s) is having accepted.' }}</h3>
      <h3 v-show="status === 3">{{ t.bet_has_been_accepted || '3/3 The Bet(s) has been accepted.' }}</h3>
      <div class="bg"></div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'countDownLoader',
  data () {
    return {
      t: this.$root.t,
      show: 0,
      status: 0,
      cs: 10
    }
  },
  beforeUnmount() {

    this.$bus.$off('betCreated');
    this.$bus.$off('betError');
    this.$bus.$off('betCreating');
  },
  mounted() {

    this.$bus.$on('betCreated', (payload) => {
      this.status = 3;
      this.show = 0;
    });

    this.$bus.$on('betError', (payload) => {
      this.status = 0;
      this.show = 0;
    });

    this.$bus.$on('betCreating', (payload) => {
      this.show = 1;

      setTimeout(() => {
        //this.status = 1
      }, 1000);

      setTimeout(() => {
       // this.status = 2
      }, 3000);
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.placing  {
  left: 0;
  top: 0;
  position: fixed;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  padding: 40vh;
  text-align: center;
  backdrop-filter: blur(3px);
}

.bg  {
  left: 0;
  top: 0;
  position: absolute;
  z-index: -1;
  width: 100vw;
  height: 100vh;
  /* background: url(/static/assets/img/alex-morgann.png) no-repeat center center; */
  padding: 30vh;
  text-align: center;
  opacity: 0.4;
}


.placing h3{
  color: #c8102e;
  font-size: 12px;
}

.placing svg{
  height: 100px;
  margin: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/countdownLoader.vue